export const CASCADE_ERROR_CODES = [
    'OnlineEventDateRequiredByEmailRule',
    'OnlineEventModeChangeOrphansEmailRule',
];
/**
 * Try to interpret a 422 API response as a Web-update cascade error.
 * The API returns the error code + a list of blocking email touchpoints when
 * the requested mutation would orphan one or more anchored email rules.
 * Returns null if the response doesn't match the cascade shape.
 */
export function parseCascadeError(response) {
    if (!response.error)
        return null;
    let payload;
    try {
        payload = JSON.parse(response.error);
    }
    catch {
        return null;
    }
    if (!payload || typeof payload !== 'object')
        return null;
    const candidate = payload;
    if (typeof candidate.errorCode !== 'string')
        return null;
    if (!isCascadeErrorCode(candidate.errorCode))
        return null;
    if (!Array.isArray(candidate.blockedBy))
        return null;
    const blockedBy = [];
    for (const raw of candidate.blockedBy) {
        if (!raw || typeof raw !== 'object')
            continue;
        const entry = raw;
        if (typeof entry.touchPointId !== 'string')
            continue;
        blockedBy.push({
            touchPointId: entry.touchPointId,
            name: typeof entry.name === 'string' ? entry.name : '(unnamed)',
            ruleSummary: typeof entry.ruleSummary === 'string' ? entry.ruleSummary : '',
        });
    }
    return { errorCode: candidate.errorCode, blockedBy };
}
function isCascadeErrorCode(value) {
    return CASCADE_ERROR_CODES.includes(value);
}
